export default "__VITE_ASSET__W8eGD9Ef__"